<template>
  <div class="air-calendar-month__container flex vertical" :class="{ 'hover-effect': hoverEffect }" :style="{ margin }">
    <div class="air-calendar-month__title w100 flex acenter">
      {{ $formatMoment(`${year}-${month}`, lang === 'zh' ? 'YYYY年MM月' : 'YYYY-MM') }}
    </div>
    <div class="air-calendar-month__body full">
      <div class="month__week-title w100 flex jbetween acenter">
        <span v-for="title in weekTitles" :key="title">{{ title }}</span>
      </div>
      <div class="month__days flex jbetween acenter wrap">
        <div v-for="dayObj in preFillUpDays" class="day__body day--fill-up">
          <div class="day__box">
            <span>{{ dayObj.day }}</span>
          </div>
        </div>
        <div v-for="dayObj in days" class="day__body">
          <el-popover
            placement="right"
            width="130"
            popper-class="air-calendar-month__popper"
            v-model="dayObj.popShow"
            :trigger="disabled ? 'manual' : 'click'"
          >
            <div class="full flex vertical">
              <span class="popper__date">{{ $formatMoment(dayObj.date, 'M月DD日') }}</span>
              <div class="popper__button popper__button--work" @click="setType(dayObj, '工作日')">
                <div class="button__dot"></div>
                <span class="button__text">{{ $t('datePicker.workday') }}</span>
              </div>
              <div class="popper__button popper__button--rest" @click="setType(dayObj, '休息日')">
                <div class="button__dot"></div>
                <span class="button__text">{{ $t('datePicker.dayOff') }}</span>
              </div>
              <div class="popper__button popper__button--holiday" @click="setType(dayObj, '法定节假日')">
                <div class="button__dot"></div>
                <span class="button__text">{{ $t('datePicker.statutoryHoliday') }}</span>
              </div>
            </div>
            <div slot="reference" class="day__box day__box-oper" :class="{ today: dayObj.date === $today(), enabled: !disabled }" tabindex="1" @click="clickDay(dayObj)">
              <div v-if="showDayTips(dayObj)" class="day__tips flex center" :class="dayTipsClassObj[dayObj.type]">
                <span>{{ dayObj.type === '工作日' ? '班' : dayObj.type.substring(0, 1) }}</span>
              </div>
              <span :class="{ weekend: dayObj.dayOfWeek === 6 || dayObj.dayOfWeek === 7 }">{{ dayObj.day }}</span>
              <!--<div v-if="dayObj.date === $today()" class="day__today-dot"></div>-->
            </div>
          </el-popover>
        </div>
        <div v-for="dayObj in sufFillUpDays" class="day__body day--fill-up">
          <div class="day__box">
            <span>{{ dayObj.day }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
export default {
  name: 'MonthCalendar',
  props: {
    month: {
      type: [String, Number],
      default: ''
    },
    year: {
      type: [String, Number],
      default: ''
    },
    initCalendar: {
      type: Object,
      default () {
        return {}
      }
    },
    margin: {
      type: String,
      default: '0 0 24px 0'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hoverEffect: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters([
      'lang'
    ]),
    getWeeks() {
      const weeks = this.$t('el.datepicker.weeks');
      return weeks;
    },
    weekTitles() {
      return [this.getWeeks.mon, this.getWeeks.tue, this.getWeeks.wed, this.getWeeks.thu, this.getWeeks.fri, this.getWeeks.sat, this.getWeeks.sun]
    }
  },
  data() {
    return {
      days: [],
      preFillUpDays: [],
      sufFillUpDays: [],
      dayTipsClassObj: {
        无: '',
        工作日: 'day__tips--work',
        休息日: 'day__tips--rest',
        法定节假日: 'day__tips--holiday'
      }
    }
  },
  watch: {
    year() {
      this.init()
    },
    initCalendar() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (!this.year || !this.month) return []
      this.days = []
      this.preFillUpDays = []
      this.sufFillUpDays = []

      const monthFirstDate = this.$day(`${this.year}-${this.month}-01`)
      // 初始化本月日数组
      for (let i = 1; i <= monthFirstDate.daysInMonth(); i++) {
        const date = this.$day(`${this.year}-${this.month}-${i}`)
        const dateStr = date.format('YYYY-MM-DD')
        this.days.push({
          day: i,
          date: dateStr,
          dayOfWeek: this.$adjustWeekday(date.day()),
          type: this.initCalendar[dateStr] || '无',
          popShow: false
        })
      }

      // 日历固定显示6行，每月需要显示42天
      // 首先找出本月第一天是周几
      const monthFirstDayOfWeek = this.$adjustWeekday(monthFirstDate.day())
      // 往前需要补的天数
      const preFillUpDayCount = monthFirstDayOfWeek - 1
      if (preFillUpDayCount > 0) {
        // 获取上个月的总天数
        const lastMonthDayCount = monthFirstDate.subtract(1, 'month').daysInMonth()
        // 填充上月日数组
        for (let i = lastMonthDayCount - preFillUpDayCount + 1; i <= lastMonthDayCount; i++) {
          const date = monthFirstDate.subtract(1, 'month').date(i)
          this.preFillUpDays.push({
            day: i,
            date: date.format('YYYY-MM-DD'),
            dayOfWeek: this.$adjustWeekday(date.day()),
            type: '无',
            popShow: false
          })
        }
      }

      // 计算如果要补满42天还差几天
      const sufFillUpDayCount = 42 - this.preFillUpDays.length - this.days.length
      // 填充下月日数组
      for (let i = 1; i <= sufFillUpDayCount; i++) {
        const date = monthFirstDate.add(1, 'month').date(i)
        this.sufFillUpDays.push({
          day: i,
          date: date.format('YYYY-MM-DD'),
          dayOfWeek: this.$adjustWeekday(date.day()),
          type: '无',
          popShow: false
        })
      }
    },
    clickDay(dayObj) {
      this.$emit('day-click', dayObj)
    },
    setType(dayObj, type) {
      dayObj.type = type
      dayObj.popShow = false
      this.$emit('day-type-change', { dayObj, type })
    },
    showDayTips(dayObj) {
      // 如果是周一至周五，则设置为工作日约等于没设置，如果是周六日，则设置为休息日约等于没设置
      return dayObj.type !== '无' && ((dayObj.dayOfWeek <= 5 && dayObj.type !== '工作日') || (dayObj.dayOfWeek >= 6 && dayObj.type !== '休息日'))
    }
  }
}
</script>

<style lang="scss" scoped>
.air-calendar-month__container {
  width: 405px;
  height: 320px;
  background: #FFFFFF;
  border-radius: 6px;
  transition: border 0.3s ease;

  &.hover-effect {
    border: 1px solid #FFFFFF;

    &:hover {
      border: 1px solid #2A61FF;
    }
  }

  .air-calendar-month__title {
    height: 52px;

    span {
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 22px;
      margin-left: 23px;
    }
  }

  .air-calendar-month__body {
    padding: 0 5px;

    .month__week-title {
      height: 30px;
      background: #F6F9FF;

      span {
        width: 56px;
        text-align: center;
        height: 17px;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #3E475D;
        line-height: 17px;
      }
    }

    .month__days {
      .day__body {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 56px;
        height: 40px;

        .day__box {
          width: 28px;
          height: 28px;
          border-radius: 6px;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: background 0.3s ease;
          position: relative;
          cursor: default;

          &.today {
            background: #FF9601;

            span {
              color: #FFFFFF !important;
            }
          }
          span {
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #3E475D;
            line-height: 17px;
            transition: color 0.3s ease;

            &.weekend {
              color: #DD2B2B;
            }
          }

          &.day__box-oper {
            &.enabled {
              cursor: pointer;

              &:hover, &:focus {
                background: #2A61FF;

                span {
                  color: #FFFFFF;
                }
              }
            }
            .day__tips {
              position: absolute;
              top: -4px;
              right: -10px;
              width: 18px;
              height: 18px;
              border-radius: 50%;

              span {
                font-size: 12px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
              }

              &.day__tips--work {
                background: #EFF0F3;

                span {
                  color: #666666;
                }
              }
              &.day__tips--rest {
                background: #E7F6EF;

                span {
                  color: #14AA66;
                }
              }
              &.day__tips--holiday {
                background: #FFEAEA;

                span {
                  color: #DD2B2B;
                }
              }
            }
            .day__today-dot {
              position: absolute;
              top: 23px;
              width: 4px;
              height: 4px;
              background: #2A61FF;
              border-radius: 50%;
            }
          }
        }

        &.day--fill-up {
          .day__box {
            span {
              color: #C4C4C4;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
//工作日历弹出框
.air-calendar-month__popper {
  min-width: 130px;
  padding: 0 12px 3px;

  .popper__date {
    height: 17px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 17px;
    margin: 10px 0;
  }
  .popper__button {
    width: 100%;
    height: 28px;
    border-radius: 6px;
    margin-bottom: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    .button__dot {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin-right: 6px;
    }
    .button__text {
      height: 17px;
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 17px;
    }

    &.popper__button--work {
      background: #EFF0F3;

      .button__dot {
        background: #333333;
      }
      .button__text {
        color: #333333;
      }
    }
    &.popper__button--rest {
      background: #EEF8F4;

      .button__dot {
        background: #3EA46C;
      }
      .button__text {
        color: #3EA46C;
      }
    }
    &.popper__button--holiday {
      background: #FBE9E9;

      .button__dot {
        background: #DD2B2B;
      }
      .button__text {
        color: #DD2B2B;
      }
    }
  }
}
</style>
